import { Box, Tab, Tabs } from '@mui/material';
import { portalPaths, UrlSegments } from '@provision/portal-routes';
import { Route, Routes } from 'react-router-dom';
import { NamedLayoutBlock } from 'src/components';
import { useGroupRules, UserGroupRules } from 'src/graphql';
import { ProtectedPage } from 'src/routes/components/protected-page';
import { useNavigateRoute } from 'src/utils/routing';
import { ChannelsEmailView } from './channels-email-view';
import { ChannelsVoiceView } from './channels-voice-view';

const VOICE_CHANNEL_RULES = [UserGroupRules.AccessToManageVoiceChannelSettings];

const tabs = [
  {
    value: portalPaths.settings.channels(),
    label: 'Email',
  },
  {
    value: portalPaths.settings.channelsVoice(),
    label: 'Voice',
  },
];

export const Channels = () => {
  const { navigate, pathnameWithoutPrefix } = useNavigateRoute();
  const { checkValidity } = useGroupRules();
  // Email is the only other tab, so without Voice there is nothing to switch between.
  const showTabs = checkValidity(VOICE_CHANNEL_RULES);

  return (
    <NamedLayoutBlock
      title="Channels"
      sx={{
        flex: 1,
        display: { sm: 'flex' },
      }}
    >
      {showTabs ? (
        <Box
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            marginBottom: '1rem',
          }}
        >
          <Tabs
            aria-label="Tab navigation"
            value={pathnameWithoutPrefix}
            variant="standard"
            TabIndicatorProps={{
              sx: {
                backgroundColor: (theme) => theme.palette.custom.OV.sys.primary,
              },
            }}
          >
            {tabs.map((el) => (
              <Tab
                key={el.label}
                label={el.label}
                value={el.value}
                onClick={() => navigate(el.value)}
                sx={{
                  color: (theme) => theme.palette.custom.OV.sys.onSurface,
                  '&.Mui-selected': {
                    color: (theme) => theme.palette.custom.OV.sys.primary,
                  },
                }}
              />
            ))}
          </Tabs>
        </Box>
      ) : null}

      <Routes>
        <Route path="/" element={<ChannelsEmailView />} />
        <Route
          element={
            <ProtectedPage
              redirectTo={portalPaths.settings.channels()}
              allowedRules={VOICE_CHANNEL_RULES}
            />
          }
        >
          <Route path={UrlSegments.settings.channelsVoice} element={<ChannelsVoiceView />} />
        </Route>
      </Routes>
    </NamedLayoutBlock>
  );
};
